/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { memo } from 'react';
import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { type Plugins, type PluginLocation } from '../../../plugins/types';
import { useInvitePeopleData } from './useInvitePeopleData';

const styles = cssMap({
	formSection: {
		marginBottom: token('space.200', '16px'),
	},
});

interface PluginRendererProps {
	plugins?: Plugins;
	location: PluginLocation;
}

export const PluginRenderer = memo(({ plugins, location }: PluginRendererProps) => {
	const invitePeopleData = useInvitePeopleData();
	const plugin = plugins?.[location];

	if (!plugin) {
		return null;
	}

	return (
		<Box key={`plugin-${location}`} xcss={styles.formSection}>
			{plugin.render(invitePeopleData)}
		</Box>
	);
});
